import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./graphql/queries";
import * as i3 from "../services/querify.service";
var SegmentApi = /** @class */ (function () {
    function SegmentApi(apollo, queries, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.querify = querify;
    }
    SegmentApi.prototype.search = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.segmentsPaginated(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['segments'];
        }));
    };
    SegmentApi.prototype.searchOne = function (maintenanceTypeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: this.queries.searchSegment(),
                        variables: { id: maintenanceTypeId }
                    }).toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['segment'];
                    })];
            });
        });
    };
    SegmentApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SegmentApi_Factory() { return new SegmentApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.QuerifyService)); }, token: SegmentApi, providedIn: "root" });
    return SegmentApi;
}());
export { SegmentApi };
